// src/utils/globalAlert.js
import { useAlert } from "../bookingContext/AlertContext";

let globalAlertFn = null;

export const registerGlobalAlert = (fn) => {
  globalAlertFn = fn;
};

export const showGlobalAlert = (type, mode, message, duration = 4000) => {
  if (globalAlertFn) globalAlertFn(type, mode, message, duration);
  else console.warn("⚠️ Global alert system not yet registered.");
};
